//Actions
export const NEXT_STATE = 'NEXT_STATE'
export const SET_PARAMS = 'SET_PARAMS'
//State names
export const STATE_START = 'STATE_START'
export const STATE_CHOISIR_REGION = 'STATE_CHOISIR_REGION';
export const STATE_CHOISIR_TYPE_BIEN = 'STATE_CHOISIR_TYPE_BIEN';
export const STATE_CHOISIR_PRIX = 'STATE_CHOISIR_PRIX'
export const STATE_CHOISIR_SITUATION = 'STATE_CHOISIR_SITUATION';

//Specific to Wallonie 
export const STATE_CHOISIR_REVENU_CADASTRAL = 'STATE_CHOISIR_REVENU_CADASTRAL';
export const STATE_CHOISIR_PRESSION_IMMOBILIERE = 'STATE_CHOISIR_PRESSION_IMMOBILIERE';
export const STATE_CHOISIR_PROPRIETAIRE_HABITAT =  'STATE_CHOISIR_PROPRIETAIRE_HABITAT';
export const STATE_CHOISIR_PROPRIETAIRE_AUTRE = 'STATE_CHOISIR_PROPRIETAIRE_AUTRE';
export const STATE_CHOISIR_OCCUPER_IMMEUBLE = 'STATE_CHOISIR_OCCUPER_IMMEUBLE'
export const STATE_CHOISIR_PROPRIETAIRE_TOTALITE_AUTRE_IMMEUBLE = 'STATE_CHOISIR_PROPRIETAIRE_TOTALITE_AUTRE_IMMEUBLE'


//End
export const STATE_FIN = 'STATE_FIN'
//Autre
export const CELIBATAIRE = 'CELIBATAIRE'
export const CONJOINT = 'CONJOINT'
export const AUTRES_PERSONNES = 'AUTRES_PERSONNES'
export const SOCIETE = 'SOCIETE'

export const HABITATION = 'HABITATION'
export const TERRAIN = 'TERRAIN'
export const AUTRE_TYPE_IMMEUBLE = 'AUTRE_TYPE_IMMEUBLE'

export const OUI = 'OUI';
export const NON = 'NON';
export const SAIT_PAS = 'SAIT_PAS';

export const WALLONIE = 'WALLONIE';
export const BRUXELLES = 'BRUXELLES';
export const FLANDRE = 'FLANDRE';






// WEBPACK FOOTER //
// ./src/store/constants/questions.js